import { $http } from "@/utils/https"; // eslint-disable-next-line
import { fixPage, globalLoader } from "@/helpers/variables/index";

import tokenUtils from "@/utils/tokens";

import {
    AUTH_FORGET_TOKEN,
    AUTH_LOADING_REGISTRATION,
    AUTH_LOADING_SING_IN,
    AUTH_RESTORE_PASSWORD_LOADING,
    AUTH_SET_NEW_PASSWORD_LOADING,
    AUTH_SHOW_POPUP_NEW_PASSWORD,
    AUTH_SHOW_POPUP_RESTORE_PASSWORD,
    AUTH_STORE_TOKEN,
} from "../mutation-types";
import {
    AUTH_ACTIVATION_EMAIL,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REGISTRATION,
    AUTH_REMOVE_TOKENS,
    AUTH_RESTORE_PASSWORD,
    AUTH_SET_NEW_PASSWORD,
    AUTH_SET_TOKEN,
    AUTH_SET_TOKENS,
    AUTH_WITH_SOCIAL,
} from "../action-types";

const state = {
    isAuthenticated: false,
    showRestorePassword: false,
    loadingRestorePassword: false,
    showSetNewPassword: false,
    loadingRegistration: false,
    loadingSingIn: false,
    loadingSetPassword: false,
};

const getters = {
    isAuthenticated: (state) => state.isAuthenticated,
    loadingSingIn: (state) => state.loadingSingIn,
    loadingRestorePassword: (state) => state.loadingRestorePassword,
    loadingSetPassword: (state) => state.loadingSetPassword,
    showRestorePassword: (state) => state.showRestorePassword,
    showSetNewPassword: (state) => state.showSetNewPassword,
    loadingRegistration: (state) => state.loadingRegistration,
};

const actions = {
    [AUTH_LOGIN]: async ({ dispatch, commit }, payload) => {
        try {
            commit(AUTH_LOADING_SING_IN, true);

            const result = await $http.post(
                `${process.env.VUE_APP_ROOT_AUTH}tokens`,
                payload
            );

            dispatch(AUTH_SET_TOKENS, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(AUTH_LOADING_SING_IN, false);
        }
    },
    [AUTH_WITH_SOCIAL]: async ({ dispatch, commit }, payload) => {
        try {
            commit(AUTH_LOADING_SING_IN, true);
            commit(AUTH_LOADING_REGISTRATION, true);

            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_USER}users/socials`,
                payload
            );

            dispatch(AUTH_SET_TOKENS, response.data.data.tokens.data);
        } catch (e) {
            throw e;
        } finally {
            commit(AUTH_LOADING_SING_IN, false);
            commit(AUTH_LOADING_REGISTRATION, false);
        }
    },
    [AUTH_LOGOUT]: async ({ dispatch }) => {
        try {
            globalLoader(true);

            // this method does not exists on the API
            // const payload = {
            //     _method: 'delete',
            // };

            // return await $http.post('v1/logout', payload);
        } catch (e) {
            throw e;
        } finally {
            dispatch(AUTH_REMOVE_TOKENS);

            globalLoader(false);
        }
    }, // eslint-disable-next-line
    [AUTH_REGISTRATION]: async ({ dispatch, commit }, payload) => {
        try {
            commit(AUTH_LOADING_REGISTRATION, true);

            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_USER}users`,
                payload
            );

            dispatch(AUTH_SET_TOKENS, response.data.data.tokens.data);

            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(AUTH_LOADING_REGISTRATION, false);
        }
    },
    [AUTH_RESTORE_PASSWORD]: async ({ commit }, payload) => {
        try {
            commit(AUTH_RESTORE_PASSWORD_LOADING, true);

            return await $http.post(
                `${process.env.VUE_APP_ROOT_USER}passwords/reminders`,
                payload
            );
        } catch (e) {
            throw e;
        } finally {
            commit(AUTH_RESTORE_PASSWORD_LOADING, false);
        }
    }, // eslint-disable-next-line
    [AUTH_SET_NEW_PASSWORD]: async ({ commit }, payload) => {
        try {
            commit(AUTH_SET_NEW_PASSWORD_LOADING, true);

            return await $http.post(
                `${process.env.VUE_APP_ROOT_USER}passwords/reminders`,
                payload
            );
        } catch (e) {
            throw e;
        } finally {
            commit(AUTH_SET_NEW_PASSWORD_LOADING, false);
        }
    }, // eslint-disable-next-line
    [AUTH_ACTIVATION_EMAIL]: async ({ commit }, payload) => {
        try {
            globalLoader(true);

            return await $http.post("v1/activation", payload);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [AUTH_SET_TOKENS]: ({ dispatch }, tokens) => {
        for (let i in tokens) {
            dispatch(AUTH_SET_TOKEN, tokens[i]);
        }
    },
    [AUTH_REMOVE_TOKENS]({ commit }) {
        for (let i in tokenUtils.tokenTypes) {
            commit(AUTH_FORGET_TOKEN, tokenUtils.tokenTypes[i]);
        }
    },

    [AUTH_SET_TOKEN]: ({ commit }, tokenObject) => {
        commit(AUTH_STORE_TOKEN, tokenUtils.prepareToken(tokenObject));
    },
};

const mutations = {
    [AUTH_STORE_TOKEN](state, tokenObject) {
        localStorage.setItem(tokenObject.type + "_token", JSON.stringify(tokenObject));

        state.isAuthenticated = true;
    },
    [AUTH_FORGET_TOKEN](state, tokenKey) {
        localStorage.removeItem(tokenKey + "_token");

        state.isAuthenticated = false;
    },
    [AUTH_SHOW_POPUP_RESTORE_PASSWORD](state, status) {
        state.showRestorePassword = status;

        fixPage(status);
    },
    [AUTH_RESTORE_PASSWORD_LOADING](state, status) {
        state.loadingRestorePassword = status;
    },
    [AUTH_SET_NEW_PASSWORD_LOADING](state, status) {
        state.loadingSetPassword = status;
    },
    [AUTH_LOADING_REGISTRATION](state, status) {
        state.loadingRegistration = status;
    },
    [AUTH_LOADING_SING_IN](state, status) {
        state.loadingSingIn = status;
    },
    [AUTH_SHOW_POPUP_NEW_PASSWORD](state, status) {
        state.showSetNewPassword = status;
        fixPage(status);
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
